import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { WsService } from '../services/ws.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private keycloak: Keycloak,
    private wsService: WsService
  ) {}

  async initAfterAuth(): Promise<void> {
    if (!this.keycloak.authenticated) {
      return;
    }

    await this.wsService.connect();
  }
}
